"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H1 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.H1 = (0, styled_components_1.default)('h1') `
  color: var(--brand-color, #7B4EF8);
  leading-trim: both;
  text-edge: cap;
  font-family: Phenomena, sans-serif;
  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  margin-bottom: 0;
  width: 100%;
  margin: 10px 0
`;
